import React from 'react';
import ResourceMenu from './ResourceMenu';

export const Aside = () => {
	return (
		<aside className="sidebarNavigation">
			<h2>Resources</h2>
			<ResourceMenu />
		</aside>
	);
};

export default Aside;
